import * as customerProjectsActions from '../actions/customer-projects.actions';
import { CustomerProjectApiModel } from 'app/models/customer-project-api.model';
import { setActiveCompany } from '@core/auth/@store/user/user.actions';
import { createReducer, on, Action } from '@ngrx/store';

export interface State {
  customerProjects: CustomerProjectApiModel[];
  isLoading: boolean;
  isReady: boolean;
  totalCustomerProjects: number;
  isSaving: boolean;
}

export const initialState: State = {
  customerProjects: [],
  isLoading: false,
  isReady: false,
  totalCustomerProjects: 0,
  isSaving: false,
};

const featureReducer = createReducer(
  initialState,
  on(customerProjectsActions.loadCustomerProjects, (state: State) => ({
    ...state,
    isLoading: true,
    isReady: false,
  })),
  on(
    customerProjectsActions.loadCustomerProjectsSuccess,
    (state: State, { response }) => ({
      ...state,
      isLoading: false,
      isReady: true,
      customerProjects: response.results,
      totalCustomerProjects: response.count,
    })
  ),
  on(
    customerProjectsActions.createCustomerProject,
    customerProjectsActions.updateCustomerProject,
    (state) => ({
      ...state,
      isSaving: true,
    })
  ),
  on(
    customerProjectsActions.createCustomerProjectSuccess,
    customerProjectsActions.createCustomerProjectFailed,
    customerProjectsActions.updateCustomerProjectSuccess,
    customerProjectsActions.updateCustomerProjectFailed,
    (state) => ({
      ...state,
      isSaving: false,
    })
  ),
  on(
    customerProjectsActions.resetCustomerProjects,
    setActiveCompany,
    (state: State) => initialState
  )
);

export function reducer(state: State | undefined, action: Action): State {
  return featureReducer(state, action);
}
